export const CONSTANTS = {
  HEADER: $localize`Notes`,
  SSC_DESCRIPTION: $localize`SSC Description`,
  ADDITIONAL_INFORMATION: $localize`Additional Information`,
  DRIVER_REPLY: $localize`Driver Reply`,
  ADDITIONAL_INFORMATION_PLACEHOLDER: $localize`Enter Additional Information`,
  DRIVER_REPLY_PLACEHOLDER: $localize`Enter Driver Reply`,
};
